export const UPDATE_RUN_TAB = 'UPDATE_RUN_TAB';
export const GET_DISABLED_TABS = 'GET_DISABLED_TABS';